import { SelectedCoworkingType } from 'shared/enums/SelectedCoworkingType';

import { ECoworkingSwitcherType } from '../types';

export function getSelectedCategory(
  type: SelectedCoworkingType,
  isFlexOfficeAvailable: boolean,
): ECoworkingSwitcherType {
  switch (type) {
    case SelectedCoworkingType.FixedWorkplace:
    case SelectedCoworkingType.FlexibleWorkplace:
      return ECoworkingSwitcherType.Places;

    case SelectedCoworkingType.SeparateOffice:
      return ECoworkingSwitcherType.Office;

    case SelectedCoworkingType.None:
    default:
      return isFlexOfficeAvailable ? ECoworkingSwitcherType.Office : ECoworkingSwitcherType.Places;
  }
}
